import { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useHotkeys } from "react-hotkeys-hook";
import { SHORTCUTS } from "../../utils/shortcuts";
import ShortcutsCheatsheet from "./ShortcutsCheatsheet";

const NAV_TARGETS = {
  GO_ADMISSIONS: "/admissions",
  GO_ORDONNANCES: "/prescription",
  GO_TABLE: "/table",
  GO_CODES: "/code",
  GO_STATS: "/",
  GO_QUESTIONS: "/question",
};

const GlobalShortcuts = ({ user }) => {
  const history = useHistory();
  const [showCheatsheet, setShowCheatsheet] = useState(false);
  const isAdmin = user.role === "admin" || user.role === "superadmin";

  // useKey matches event.key (the resulting character) instead of physical key + modifiers,
  // so "?" fires from any layout — US (Shift+/), French AZERTY (Shift+,), etc.
  useHotkeys(SHORTCUTS.OPEN_CHEATSHEET.keys, () => setShowCheatsheet((prev) => !prev), { preventDefault: true, useKey: true });

  const navigate = useCallback((path) => history.push(path), [history]);

  useHotkeys(SHORTCUTS.GO_ADMISSIONS.keys, () => navigate(NAV_TARGETS.GO_ADMISSIONS));
  useHotkeys(SHORTCUTS.GO_ORDONNANCES.keys, () => navigate(NAV_TARGETS.GO_ORDONNANCES));
  useHotkeys(SHORTCUTS.GO_TABLE.keys, () => navigate(NAV_TARGETS.GO_TABLE), { enabled: isAdmin });
  useHotkeys(SHORTCUTS.GO_CODES.keys, () => navigate(NAV_TARGETS.GO_CODES), { enabled: isAdmin });
  useHotkeys(SHORTCUTS.GO_STATS.keys, () => navigate(NAV_TARGETS.GO_STATS), { enabled: isAdmin });
  useHotkeys(SHORTCUTS.GO_QUESTIONS.keys, () => navigate(NAV_TARGETS.GO_QUESTIONS), { enabled: isAdmin });

  if (!showCheatsheet) return null;
  return <ShortcutsCheatsheet isAdmin={isAdmin} onClose={() => setShowCheatsheet(false)} />;
};

export default GlobalShortcuts;
